.infoText {
  color: var(--body-text-arrows-400);
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

#firewall-networks-text {
  margin-bottom: calc(var(--spacer) * -3); // remove extra space added by grid
}

#firewall-adapters-text {
  margin-bottom: calc(var(--spacer) * -2); // remove extra space added by grid
}

#adapters-items-form-field {
  width: 100%;
}
